import React, { useEffect, useRef, useState } from 'react';

const HomeMainPCListTooltip = ({ products, openLink }) => {
  const tooltipRef = useRef();
  const [isShowTooltip, setIsShowTooltip] = useState(false);

  const showTooltip = () => setIsShowTooltip(true);
  const hideTooltip = () => setIsShowTooltip(false);
  const handleHideTooltip = event => {
    const paths = event.path || (event.composePath && event.composePath());
    const isTooltipClick = paths.some(
      element => element === tooltipRef?.current,
    );

    if (isShowTooltip && !isTooltipClick) hideTooltip();
  };

  useEffect(() => {
    window.addEventListener('click', handleHideTooltip);
    return () => {
      window.removeEventListener('click', handleHideTooltip);
    };
  });

  return (
    <div className="tooltip-wrap">
      <button
        type="button"
        className={$classNames('btn-tooltip', { active: isShowTooltip })}
        onClick={showTooltip}
      >
        선택 +
      </button>

      {isShowTooltip && (
        <div className="tooltip-box" ref={tooltipRef}>
          <ul className="insu-pro-list">
            {products.map(({ compCd, productName }, index) => (
              <li key={index} onClick={() => openLink(compCd)}>
                <a href="#">{productName}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default HomeMainPCListTooltip;
